import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ModalMaterial from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

function getModalStyle() {
  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  };
}

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      position: 'absolute',
      width: 700,
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100vh - 32px)',
      boxSizing: 'border-box',
      overflowY: 'auto',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      outline: 0,
    },
  })
);

//This component renders a button that throws the modal
const Modal = ({
  buttonName,
  type = 'button',
  title,
  content,
  onOpen,
  onChange,
}) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    onOpen !== undefined && setOpen(onOpen);
  }, [onOpen]);

  const handleOpen = () => {
    setOpen(true);
    onChange(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button className={type} type="button" onClick={handleOpen}>
        <span>{buttonName}</span>
      </button>
      <ModalMaterial
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
      >
        <div style={modalStyle} className={classes.paper}>
          <div className="modal">
            <div className="modal__title">
              <h3 id="simple-modal-title" className="title">
                {title}
              </h3>
              <button
                type="button"
                className="title__close"
                aria-label="Cerrar modal"
                onClick={handleClose}
              >
                <CloseIcon className="close__icon" />
              </button>
            </div>
            {content}
          </div>
        </div>
      </ModalMaterial>
    </>
  );
};

Modal.propTypes = {
  buttonName: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.node,
};

export default Modal;
